import { render } from "./LoaderUi.vue?vue&type=template&id=587ae88c&ts=true"
import script from "./LoaderUi.vue?vue&type=script&lang=ts"
export * from "./LoaderUi.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__